export default __webpack_public_path__ + "static/media/yggdrasil.96b3752d.svg";